/* SIFT product template — buy box, carousels, UI. Every lookup is guarded so
   sections can be reordered or removed in the theme editor without breaking. */
(function () {
  'use strict';

  var $ = function (id) { return document.getElementById(id); };
  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  /* ---------------- mobile card carousels + dots ---------------- */
  function initCarousels() {
    if (!window.matchMedia || !window.matchMedia('(max-width:980px)').matches) return;
    Array.prototype.forEach.call(document.querySelectorAll('.sl-sc'), function (sc) {
      if (sc.dataset.slDots) return;
      sc.dataset.slDots = '1';
      var n = sc.children.length;
      if (n < 2) return;
      var d = document.createElement('div');
      d.className = 'sl-dots';
      for (var i = 0; i < n; i++) {
        var t = document.createElement('i');
        if (!i) t.className = 'on';
        d.appendChild(t);
      }
      sc.parentNode.insertBefore(d, sc.nextSibling);
      sc.addEventListener('scroll', function () {
        var idx = Math.min(n - 1, Math.round(sc.scrollLeft / (sc.scrollWidth / n)));
        for (var j = 0; j < d.children.length; j++) {
          d.children[j].className = (j === idx ? 'on' : '');
        }
      }, { passive: true });
    });
  }

  /* ---------------- FAQ accordions ---------------- */
  function initAccordions() {
    Array.prototype.forEach.call(document.querySelectorAll('.sl-acc'), function (acc) {
      if (acc.dataset.slInit) return;
      acc.dataset.slInit = '1';
      acc.addEventListener('click', function (e) {
        var q = e.target.closest('.sl-q');
        if (!q || !acc.contains(q)) return;
        var open = q.getAttribute('aria-expanded') === 'true';
        var panel = q.nextElementSibling;
        q.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.style.maxHeight = open ? '0px' : (panel.scrollHeight + 20) + 'px';
      });
    });
  }

  /* ---------------- countdown in the announcement bar ---------------- */
  function initClock() {
    var h = $('slH'), m = $('slM'), s = $('slS');
    if (!h || !m || !s) return;
    function tick() {
      var n = new Date();
      var end = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1, 0, 0, 0);
      var d = Math.max(0, Math.floor((end - n) / 1000));
      h.textContent = String(Math.floor(d / 3600)).padStart(2, '0');
      m.textContent = String(Math.floor(d % 3600 / 60)).padStart(2, '0');
      s.textContent = String(d % 60).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------------- estimated ship day ---------------- */
  function initShipDay() {
    var el = $('slShipDay');
    if (!el) return;
    var d = new Date();
    d.setDate(d.getDate() + 1);
    if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    if (d.getDay() === 6) d.setDate(d.getDate() + 2);
    el.textContent = d.toLocaleDateString(undefined, { weekday: 'long', month: 'short', day: 'numeric' });
  }

  /* ---------------- scroll-to-buybox buttons ---------------- */
  function initJump() {
    document.addEventListener('click', function (e) {
      var j = e.target.closest('[data-sl-jump]');
      if (!j) return;
      var target = document.querySelector('.sl-hero');
      if (!target) return;
      e.preventDefault();
      window.scrollTo({ top: window.pageYOffset + target.getBoundingClientRect().top - 20, behavior: 'smooth' });
    });
  }

  /* ---------------- the buy box ----------------
     Liquid hands over one entry per finish, each carrying its own product:
     title, url, subscription plan, gallery and variants. Choosing a finish
     therefore switches the product that goes in the cart, not just a variant,
     which is what makes the order say which showerhead to fulfil. */
  function initBuyBox() {
    var root = $('siftBuy');
    if (!root || root.dataset.slInit) return;

    var finishes = [];
    var fEl = $('siftFinishes');
    if (fEl) { try { finishes = JSON.parse(fEl.textContent); } catch (err) { finishes = []; } }
    if (!finishes.length) return;
    root.dataset.slInit = '1';

    var saveWord = root.dataset.saveWord || 'You save';
    var showSaving = root.dataset.tierSaving === 'true';

    /* The subscription rides on the replacement filter, never on the showerhead.
       A head is bought once; the filter already inside it is the customer's
       first, so cycle one is zeroed by a discount code and nothing extra ships
       with the first order. Subscribing the head instead would rebill them for
       a whole showerhead every 90 days. */
    var filter = null;
    var flEl = $('siftFilter');
    if (flEl) {
      try { filter = JSON.parse(flEl.textContent); } catch (err) { filter = null; }
    }
    var perHead = root.dataset.filterPerHead === 'true';

    /* The showerhead carries no selling plan, so Shopify has exactly one price
       for it and the subscriber price is a discount applied to the cart. This
       is the page's half of that, and it must round the way Shopify rounds:
       the DISCOUNT is truncated to the cent — not rounded, and not the result.
       Verified against a real checkout: 25% of $119.99 is $29.9975, and
       Shopify took $29.99, charging $90.00. Math.round here showed $89.99 on
       the page and the cart charged a cent more. */
    var subPct = parseFloat(root.dataset.subDiscount) || 0;
    function subbed() { return state.plan === 'sub' && subPct > 0; }
    function eff(cents) {
      if (!subbed()) return cents;
      return cents - Math.floor(cents * subPct / 100);
    }

    var stickyBtn = $('slStickyBtn');
    var stickyLabel = stickyBtn ? stickyBtn.textContent.trim() : '';

    var state = { fi: 0, tier: root.dataset.defaultTier || '', plan: 'sub' };

    function fin() { return finishes[state.fi] || finishes[0]; }

    function variantFor(f, tier) {
      if (!f || !f.variants || !f.variants.length) return null;
      for (var i = 0; i < f.variants.length; i++) {
        if (!tier || f.variants[i].tier === tier) return f.variants[i];
      }
      return null;
    }

    function currentVariant() {
      return variantFor(fin(), state.tier) || (fin().variants || [])[0] || null;
    }

    function setText(id, val) { var e = $(id); if (e) e.textContent = val; }

    /* "3 Showers + 1 FREE" is four heads, not three, so the numbers in the label
       are summed rather than the first one taken. A tier block can state the
       count outright for a label the sum would read wrong. */
    function unitsFor(tier) {
      if (!perHead) return 1;
      var wrap = $('slTiers');
      var btn = null;
      if (wrap && tier) {
        try { btn = wrap.querySelector('[data-value="' + tier + '"]'); } catch (err) { btn = null; }
      }
      var n = btn ? parseInt(btn.getAttribute('data-units'), 10) : 0;
      if (n > 0) return n;
      var nums = String(tier || '').match(/\d+/g);
      if (!nums) return 1;
      n = nums.reduce(function (a, b) { return a + parseInt(b, 10); }, 0);
      return n > 0 ? n : 1;
    }

    /* The fixed "$34.99 every 90 days" is only true for a single head. Four
       filters is $139.96, and a customer who first sees that on their card in
       month three charges it back, so the real number goes on the page. */
    function renderPlanText() {
      var host = document.querySelector('#slPlans [data-value="sub"] p');
      if (!host || root.dataset.subDynamic !== 'true') return;
      var tpl = root.dataset.subDynamicText;
      if (!tpl || !filter || !filter.id) return;
      var n = unitsFor(state.tier);
      host.textContent = tpl
        .replace(/\{count\}/g, n === 1 ? '1 filter' : n + ' filters')
        .replace(/\{total\}/g, money(filter.price * n))
        .replace(/\{each\}/g, money(filter.price));
    }

    /* the gifts badge belongs to the first photo only — on the other shots it
       just covers part of what the customer clicked to look at */
    function setBurst(on) {
      var b = $('slBurst');
      if (b) b.style.display = on ? '' : 'none';
    }

    /* the sticky bar's price is two numbers, not one string: the compare-at has
       to read as struck through or it looks like the product costs both. The
       spacing between them is the flex gap on .sl-si>span — set inline here it
       would outrank the stylesheet and there would be no way to tune it. */
    function setStickyPrice(now, was) {
      var el = $('slStickyPrice');
      if (!el) return;
      if (el.childNodes.length !== 2) {
        el.textContent = '';
        el.appendChild(document.createElement('b'));
        el.appendChild(document.createElement('s'));
      }
      el.firstChild.textContent = now;
      el.lastChild.textContent = was;
      el.lastChild.style.display = was ? '' : 'none';
    }

    function setProp(name, value) {
      var wrap = $('siftProps');
      if (!wrap) return;
      var input = wrap.querySelector('input[data-prop="' + name + '"]');
      if (!input) return;
      input.value = value || '';
      /* an empty property name/value pair is dropped so it never shows on the order */
      input.disabled = !value;
    }

    /* prices, savings and availability are per finish, so the tier row is
       rebuilt whenever the finish changes rather than baked in by Liquid */
    function renderTiers() {
      var f = fin();
      var wrap = $('slTiers');
      if (!wrap || !f) return;
      Array.prototype.forEach.call(wrap.querySelectorAll('.sl-tier'), function (btn) {
        var tv = variantFor(f, btn.getAttribute('data-value'));
        if (!tv) { btn.hidden = true; return; }
        btn.hidden = false;
        var b = btn.querySelector('.sl-tprice b');
        var s = btn.querySelector('.sl-tprice s');
        var sub = btn.querySelector('.sl-tsub');
        if (b) b.textContent = money(eff(tv.price));
        /* on a subscription the honest comparison is the one-time price, not
           the compare-at — it is the number the customer is choosing against */
        var strike = subbed() ? tv.price : tv.compare;
        if (s) {
          s.textContent = strike ? money(strike) : '';
          s.style.display = strike ? '' : 'none';
        }
        if (sub) {
          var saved = subbed() ? tv.price - eff(tv.price) : (tv.compare ? tv.compare - tv.price : 0);
          sub.textContent = (showSaving && saved > 0)
            ? saveWord + ' ' + money(saved)
            : (btn.getAttribute('data-sub') || '');
        }

        /* The row photo has to answer two questions at once — which finish, and
           how many heads. In order of how specific the answer is: a variant
           photo settles both; the tier block's per-finish slot settles both for
           the first two finishes; its shared photo knows only the head count,
           which is why a Silver 4-pack shot used to stay on screen after
           switching to Black; the finish's lead shot is the last resort, right
           colour but a single head. */
        var img = btn.querySelector('.sl-timg');
        if (img) {
          var src = tv.img || '';
          if (!src && state.fi === 1) src = img.getAttribute('data-own2') || '';
          if (!src) src = img.getAttribute('data-own') || '';
          if (!src && f.gallery && f.gallery[0]) {
            src = f.gallery[0].replace('width=1200', 'width=160');
          }
          if (src && img.getAttribute('src') !== src) img.src = src;
        }
      });
    }

    /* the finish owns the whole gallery, not just the hero shot */
    function renderGallery() {
      var list = (fin() || {}).gallery;
      if (!list || !list.length || !list[0]) return;

      var img = $('slMain');
      if (img && img.getAttribute('src') !== list[0]) {
        img.style.opacity = '0';
        setTimeout(function () { img.src = list[0]; img.style.opacity = '1'; }, 180);
      }
      /* back to the lead shot, so the badge comes back with it */
      setBurst(true);

      /* the tier row photos are renderTiers()' job — it is the one holding the
         variant, and a blanket overwrite from here would flatten every row back
         to the lead shot and lose the head counts */

      var thumbs = $('slThumbs');
      if (!thumbs) return;
      thumbs.innerHTML = '';
      list.slice(0, 5).forEach(function (src, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.dataset.src = src;
        b.setAttribute('aria-current', i ? 'false' : 'true');
        var t = document.createElement('img');
        t.src = src.replace('width=1200', 'width=200');
        t.alt = '';
        t.loading = 'lazy';
        t.width = 200;
        t.height = 200;
        b.appendChild(t);
        thumbs.appendChild(b);
      });
    }

    function render() {
      var f = fin();
      var v = currentVariant();
      if (!f || !v) return;

      var idInput = $('siftVariantId');
      if (idInput) idInput.value = v.id;

      var headline = subbed() ? v.price : v.compare;
      var now = money(eff(v.price));
      var was = headline ? money(headline) : '';
      var saved = subbed() ? v.price - eff(v.price) : (v.compare ? v.compare - v.price : 0);
      var save = saved > 0 ? money(saved) : '';

      setText('slNow', now);
      setText('slCtaNow', now);
      setText('slCtaWas', was);
      setStickyPrice(now, was);
      setText('slFinName', f.label);
      /* The full title truncates to "Sift Filtered Show…" in the width a phone
         leaves here, which names nothing the customer can act on. What they
         cannot see once they have scrolled past the buy box is which finish and
         tier they chose — so the bar carries that, and it fits. */
      setText('slStickyName', f.label + (state.tier ? ' · ' + state.tier : ''));

      var wasEl = $('slWas');
      if (wasEl) { wasEl.textContent = was; wasEl.style.display = was ? '' : 'none'; }
      var saveEl = $('slSave');
      if (saveEl) { saveEl.textContent = save ? 'SAVE ' + save : ''; saveEl.style.display = save ? '' : 'none'; }

      var soldOut = v.available === false;
      var sub = state.plan === 'sub';
      var gifts = $('slGifts');
      if (gifts) gifts.classList.toggle('on', sub);
      setText('slGiftState', sub ? root.dataset.unlockedLabel || 'Unlocked' : 'Locked');
      setText('slGiftMsg', sub ? (root.dataset.giftsOn || '') : (root.dataset.giftsOff || ''));
      setText('slCtaText', soldOut ? 'Sold Out' : (sub ? (root.dataset.ctaSub || 'Add To Cart') : (root.dataset.ctaOne || 'Add To Cart')));

      var addBtn = $('slAdd');
      if (addBtn) addBtn.disabled = soldOut;
      if (stickyBtn) {
        stickyBtn.disabled = soldOut;
        /* no price here — it already reads once, immediately to the left */
        stickyBtn.textContent = soldOut ? 'Sold Out' : stickyLabel;
      }

      /* A disabled button is a dead end. When the chosen combination is out of
         stock the CTA still reads Sold Out, but the ask underneath it changes
         from money to an email address — the only thing left worth collecting. */
      var notify = $('slNotify');
      var notifyNote = $('slNotifyNote');
      if (notify) notify.hidden = !soldOut;
      if (notifyNote) notifyNote.hidden = !soldOut || !notifyNote.textContent.trim();

      /* keep the line-item properties in sync for both AJAX and no-JS submits */
      setProp('Finish', f.label);
      setProp('Showers', state.tier);
      setProp('Plan', sub ? (root.dataset.planSub || 'Subscribe & Save') : (root.dataset.planOne || 'One-time purchase'));
      for (var g = 1; g <= 4; g++) {
        setProp('Free Gift ' + g, sub ? (root.dataset['gift' + g] || '') : '');
      }
      setProp('Bonus', root.dataset.bonusValue && state.tier === root.dataset.bonusTier ? root.dataset.bonusValue : '');

      /* The showerhead is never subscribed. This input only feeds the plain form
         post used when JavaScript never ran, and that post can carry one line —
         so it sells the head outright rather than signing them up to rebuy one
         every 90 days. The filter's plan travels on the AJAX path instead. */
      var spInput = $('siftSellingPlan');
      if (spInput) {
        spInput.value = '';
        spInput.disabled = true;
      }

      renderPlanText();
    }

    function press(container, btn) {
      var all = container.querySelectorAll('[data-value],[data-index]');
      for (var i = 0; i < all.length; i++) {
        all[i].setAttribute('aria-pressed', all[i] === btn ? 'true' : 'false');
      }
    }

    var finishWrap = $('slFinish');
    if (finishWrap) {
      finishWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-index]');
        if (!btn || !finishWrap.contains(btn)) return;
        state.fi = parseInt(btn.getAttribute('data-index'), 10) || 0;
        press(finishWrap, btn);
        /* a product may not carry every tier — fall back to its first one */
        if (!variantFor(fin(), state.tier)) {
          var first = (fin().variants || [])[0];
          state.tier = first ? first.tier : '';
          var tw = $('slTiers');
          if (tw) {
            var match = tw.querySelector('[data-value="' + state.tier + '"]');
            if (match) press(tw, match);
          }
        }
        renderGallery();
        renderTiers();
        render();
      });
    }

    var tierWrap = $('slTiers');
    if (tierWrap) {
      tierWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-value]');
        if (!btn || !tierWrap.contains(btn)) return;
        state.tier = btn.getAttribute('data-value');
        press(tierWrap, btn);
        render();
      });
    }

    var planWrap = $('slPlans');
    if (planWrap) {
      planWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-value]');
        if (!btn || !planWrap.contains(btn)) return;
        state.plan = btn.getAttribute('data-value');
        press(planWrap, btn);
        renderTiers();
        render();
      });
    }

    var notifyBtn = $('slNotify');
    if (notifyBtn) {
      notifyBtn.addEventListener('click', function () {
        if (!window.siftNotify) return;
        var f = fin();
        var main = $('slMain');
        /* the finish and the tier both go on the customer as tags, because a
           restock is rarely the whole grid — the merchant needs to mail the
           people waiting on the combination that actually landed */
        window.siftNotify.open({
          title: f.label + (state.tier ? ' · ' + state.tier : ''),
          image: main ? main.getAttribute('src') : '',
          tags: ['bis:' + f.label, 'bis-tier:' + state.tier]
        });
      });
    }

    var thumbs = $('slThumbs');
    if (thumbs) {
      thumbs.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        var img = $('slMain');
        if (img && b.dataset.src) img.src = b.dataset.src;
        var all = this.querySelectorAll('button');
        for (var i = 0; i < all.length; i++) {
          all[i].setAttribute('aria-current', all[i] === b ? 'true' : 'false');
        }
        setBurst(all[0] === b);
      });
    }

    /* sticky bar appears once the buy box scrolls out of view */
    var hero = document.querySelector('.sl-hero');
    var sticky = $('slSticky');
    if (hero && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        sticky.classList.toggle('on', !en[0].isIntersecting);
      }, { rootMargin: '-80px 0px 0px 0px' }).observe(hero);
    }

    /* ---------------- add to cart ----------------
       /cart/add.js takes an items array with a per-item selling_plan, so the
       showerhead (one-off) and the filter (subscription) go in on one request.
       Chaining a page load per line, as the funnel used to, gave every step its
       own chance to strand someone on /cart holding half an order — and once the
       browser has navigated there is nothing left to show an error on. */
    var form = $('siftForm');
    var after = root.dataset.afterAdd || 'checkout';

    /* whatever render() left enabled — disabled inputs are dropped so an empty
       property never reaches the order */
    function currentProps() {
      var out = {};
      var wrap = $('siftProps');
      if (!wrap) return out;
      Array.prototype.forEach.call(wrap.querySelectorAll('input[data-prop]'), function (i) {
        if (!i.disabled && i.value) out[i.getAttribute('data-prop')] = i.value;
      });
      return out;
    }

    function showError(msg) {
      var el = $('slCartError');
      if (!el && form) {
        el = document.createElement('p');
        el.id = 'slCartError';
        el.className = 'sl-cart-error';
        el.setAttribute('role', 'alert');
        form.parentNode.insertBefore(el, form.nextSibling);
      }
      if (!el) return;
      el.textContent = msg || root.dataset.cartError || 'Sorry — we could not add that to your cart.';
      el.style.display = '';
    }

    function postJSON(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(
          function (j) { return { ok: r.ok, body: j }; },
          function () { return { ok: r.ok, body: null }; }
        );
      });
    }

    function submitCart(e) {
      if (e) e.preventDefault();
      var v = currentVariant();
      if (!form || !v) return;

      var btns = [$('slAdd'), $('slStickyBtn')];
      var reset = function () {
        btns.forEach(function (b) { if (b) { b.disabled = false; b.style.opacity = ''; } });
      };
      btns.forEach(function (b) { if (b) { b.disabled = true; b.style.opacity = '.65'; } });
      var prev = $('slCartError');
      if (prev) prev.style.display = 'none';

      var sub = state.plan === 'sub';
      var items = [{ id: v.id, quantity: 1, properties: currentProps() }];

      /* the filter is a separate line because it is the one carrying the plan;
         merged into the head's line it would subscribe the head as well */
      if (sub && filter && filter.id && filter.plan) {
        var line = { id: filter.id, quantity: unitsFor(state.tier), selling_plan: filter.plan };
        if (root.dataset.filterNote) {
          line.properties = { 'Replacement filters': root.dataset.filterNote };
        }
        items.push(line);
      }

      postJSON('/cart/add.js', { items: items })
        .then(function (res) {
          if (!res.ok) {
            throw new Error((res.body && (res.body.description || res.body.message)) || '');
          }
          var code = root.dataset.filterDiscount;
          if (!sub || !code || items.length < 2) return null;
          /* the code is what makes cycle one free, but a cart that misses it is
             still a valid order — never let it block the way to checkout */
          return postJSON('/cart/update.js', { discount: code }).catch(function () { return null; });
        })
        .then(function () {
          if (after === 'checkout') { window.location.href = '/checkout'; return; }
          if (after === 'cart') { window.location.href = '/cart'; return; }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          reset();
        })
        .catch(function (err) {
          /* Shopify rejects the whole request rather than adding part of it, so
             there is no half-filled cart to unpick — only a message to show */
          reset();
          showError(err && err.message);
        });
    }

    if (form) form.addEventListener('submit', submitCart);
    if (stickyBtn) stickyBtn.addEventListener('click', submitCart);

    renderTiers();
    render();
  }

  function init() {
    initBuyBox();
    initCarousels();
    initAccordions();
    initClock();
    initShipDay();
    initJump();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* re-run when a section is re-rendered in the theme editor */
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-sl-init]').forEach(function (n) { delete n.dataset.slInit; });
    init();
  });
})();
